export default __webpack_public_path__ + "static/media/done.ca296433.svg";